import PropTypes from 'prop-types';
import { useRef } from 'react';

import { Button } from '@ctct/ui-react';

// we use it with `position: absolute`, so the button is not a part of the sticky header
const WithScrollIntoViewButton = ({ scrollIntoViewButtonLabel, children }) => {
  const comparePlansWrapperRef = useRef(null);

  // width for button absolute wrapper is the width of the first table cell or undefined
  const scrollIntoViewWrapperWidth =
    // eslint-disable-next-line no-unsafe-optional-chaining
    comparePlansWrapperRef.current && [...comparePlansWrapperRef.current?.getElementsByTagName('th')][0]?.clientWidth;

  return (
    <div ref={comparePlansWrapperRef} className="compare-plan-features-wrapper">
      <div className="scroll-into-view-button-wrapper" style={{ width: scrollIntoViewWrapperWidth }}>
        <Button
          size="large"
          text={scrollIntoViewButtonLabel}
          shape="pill"
          kind="link"
          onClick={() => comparePlansWrapperRef.current?.scrollIntoView({ behavior: 'smooth' })}
        />
      </div>
      {children}
    </div>
  );
};

WithScrollIntoViewButton.propTypes = {
  children: PropTypes.node.isRequired,
  scrollIntoViewButtonLabel: PropTypes.string.isRequired,
};

export default WithScrollIntoViewButton;
